import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axiosAdmin from 'utils/axiosAdmin';
import URL from 'config/url';

export const getOrganizations = createAsyncThunk('GET ORGANIZATIONS', async (data, thunkAPI) => {
  const params = new URLSearchParams();
  params.set('page', data?.page || 1);
  params.set('limit', data?.limit || 10);
  if (data?.text) params.set('text', data.text);
  if (data?.start_date) params.set('start_date', data.start_date);
  if (data?.end_date) params.set('end_date', data.end_date);
  const response = await axiosAdmin.get(`${URL.GET_ORGANIZATIONS}?${params.toString()}`, thunkAPI);
  return response.data;
});

export const createOrgAccount = createAsyncThunk('CREATE ORG ACCOUNT', async (data, thunkAPI) => {
  const { orgId, ...payload } = data;
  const response = await axiosAdmin.post(`${URL.CREATE_ORG_ACCOUNT}/${orgId}/accounts`, payload, thunkAPI);
  return response.data;
});

const initialState = {
  isLoading: false,
  isCreatingAccount: false,
  organizationData: null,
  lastSearchParams: null,
};

export const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOrganizations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOrganizations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organizationData = action.payload.data;
        state.lastSearchParams = action.meta.arg || null;
      })
      .addCase(getOrganizations.rejected, (state, action) => {
        state.isLoading = false;
        state.organizationData = null;
        toast.error(action?.error?.message || 'Failed to fetch organizations');
      })
      .addCase(createOrgAccount.pending, (state) => {
        state.isCreatingAccount = true;
      })
      .addCase(createOrgAccount.fulfilled, (state, action) => {
        state.isCreatingAccount = false;
        toast.success(action?.payload?.message || 'Account created successfully');
      })
      .addCase(createOrgAccount.rejected, (state, action) => {
        state.isCreatingAccount = false;
        // toast.error(
        //   action?.payload?.message || action?.payload?.error || action?.error?.message || 'Failed to create account'
        // );
      });
  },
});

export default organizationSlice.reducer;
